import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BrowserService } from '../../../../shared/services/browser.service';

const AGENT_LABELS_KEY = 'agentlabels';

@Injectable({
  providedIn: 'root'
})

export class FolderTreeService extends BrowserService {
  baseUrl = `${ window['__env'].APIS.ORIGINATIONS }/Hierarchy`;
  folders = new Map();

  getByAgentId(agentId): Observable<any> {

    return super.post(`nodes/searchByAgentId`, { agentId: agentId }, { loaderName: 'hierarchy_modal_loader' }).pipe(
      tap(
        (response)=>{

          // get agent labels and save in storage
          if(response && Array.isArray(response.value) && response.value[0]){

            const labels = response.value[0].agent.labels;
            
            localStorage.setItem(AGENT_LABELS_KEY, JSON.stringify(labels));
          }
        }
      )
    );
  }

  post(name: string): Observable<any> {
    return super.post(`Root`, { name: name });
  }

  get(id = null): Observable<any> {
    if (id) {
      this.catalogsSidebar.history
        .next(super.getLog(id, ['NodeUpdated']));
    }
    return !id ? super.get('', { loader: true }) : super.post(`nodes/searchById`, { NodeId: id }, { loader: true });
  }

  postFolder(parentId: string, { name, description, groupType, NoFolderToCreate }): Observable<any> {
    return super.post(`nodes/${ parentId }/childNode`, {
      groupType,
      name,
      description,
      NoFolderToCreate
    }, { loader: true, loaderName: 'newFolder' });
  }

  updateFolder(parentId: string, { name, description, tags, agentId }): Observable<any> {
    return super.put(`nodes/${ parentId }/childNode`, {
      agentId: agentId || undefined, //Changed to send undefined if agent is empty or null
      name,
      description,
      tags,
    }, { loader: true });
  }

  delete(parentId: string): Observable<any> {
    return super.delete(`nodes/${ parentId }/childNode`, { loader: true });
  }

  searchByName(query: string): Observable<any> {
    return super.post(`nodes/searchByName`, { name: query }, { loader: true });
  }

  setMapHierarchy(obj, parent = null, index = 0) {
    const _parent = parent ? Array.from(this.browserMap.get(parent).parent) : [];
    const parents = _parent;
    if (parent) {
      parents.push(parent);
    }

    let children;
    if (obj.groups) {
      children = obj.groups.map(el => el.id);
    }


    this.browserMap.set(
      obj.id,
      {
        id: obj.id,
        parent: parents,
        name: obj.name,
        description: obj.description,
        groupType: obj.groupType,
        agent: obj.agent,
        children: children,
        status: obj.status,
        statusEvent: 0,
        index: index
      }
    );
    if (obj.groups) {
      index++;
      obj.groups.forEach(folder => {
        this.setMapHierarchy(folder, obj.id, index);
      });
    }
  }

  setCol(id) {
    const grid = [];
    const folder = this.browserMap.get(id);
    if (folder.parent.length) {
      grid.push([folder.parent[0]]);
      folder.parent.forEach(parentId => {
        grid.push(Array.from(this.browserMap.get(parentId).children));
      });
      if (this.browserMap.get(id).children !== undefined) {
        grid.push(Array.from(this.browserMap.get(id).children));
      }
    } else {
      grid.push(Array.from([id]));
      grid.push(Array.from(this.browserMap.get(id).children));
    }
    this.browserGrid$.next(grid);
    this.setStatus(id);
    this.selectedItemId$.next(id);

  }

  setStatus(id) {
    const folder = this.browserMap.get(id);
    if (folder.children !== undefined) {
      folder.children.forEach(childId => {
        this.browserMap.get(childId).statusEvent = 0;
      });
    }
    if (folder.parent.length) {
      this.browserMap.get(folder.parent[folder.parent.length - 1]).children.forEach(childId => {
        this.browserMap.get(childId).statusEvent = 0;
      });
    }
    folder.statusEvent = 1;
  }
}
